const styles = theme => ({
  container: {
    border: `1px solid ${theme.palette.primary.borderColor}`,
    borderRadius: '0px',
    padding: '16px',
    background: theme.palette.primary.white,
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },

  title: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '150%',
  },

  resetBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: 'transparent !important',
    color: theme.palette.secondary.dim,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '150%',
    textTransform: 'lowercase',
    border: '0 !important',
    boxShadow: 'none !important',
    padding: '10px',

    '&:focus': {
      background: 'transparent',
      color: theme.palette.secondary.dim,
    },

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },

  filtersList: {
    marginTop: '16px',
    '& $filter': {
      padding: '16px 0',
      borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    },
  },
  filter: {
    width: '100%',
    '& > *:not(:first-child)': {
      marginTop: '16px !important',
    },
  },
  hr: {
    width: '100%',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  showFiltersBtn: {
    width: '100%',
    background: theme.palette.primary.white,
    color: theme.palette.primary.main,
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '21px',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    textTransform: 'lowercase',
    padding: '12px',
    borderRadius: '0px',
    boxShadow: 'none',
    '& svg path': {
      fill: theme.palette.primary.main,
    },
    '&:hover': {
      background: theme.palette.primary.white,
      color: theme.palette.primary.adgmHover,
      boxShadow: 'none',
      '& svg path': {
        fill: theme.palette.primary.adgmHover,
      },
    },

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },
  showFiltersBtnIcon: {
    marginRight: '12px',
  },

  searchBtn: {
    width: '100%',
    background: '#0088FF',
    color: theme.palette.primary.white,
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: `${theme.direction === 'ltr' && 'lowercase'}`,
    padding: '12px',
    borderRadius: '0px',
    boxShadow: 'none',

    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },
});

export default styles;
